const isDefined = (arg) => arg !== undefined && arg !== null

export default isDefined
